import { z } from 'zod';
import { makeEvent } from './EventBase';

export const ApplicationUpdated = makeEvent(
    'ApplicationUpdated',
    z.object({
        application_id: z.number(),
    }),
);

export type ApplicationUpdated = (typeof ApplicationUpdated)['schema']['_output'];
